<div id="lineChartGraph" class="card">
    <p-chart type="line" #lineChart [data]="basicData" width="100%" [height]=this.height [responsive]="true" [options]="basicOptions">
    </p-chart>
</div>